import { forwardRef } from "react";
import { useTranslation } from "hhn-commons";
import {
  UnreadDividerIcon,
  UnreadDividerLabel,
  UnreadDividerLine,
  UnreadDividerPill,
  UnreadDividerRow,
} from "./UnreadMessagesDivider.style";

const UnreadMessagesDivider = forwardRef<HTMLDivElement>((props, ref) => {
  const { t } = useTranslation();
  const label = t("newMessagesDivider", { ns: "message" });

  return (
    <UnreadDividerRow ref={ref} data-testid="unread-messages-divider" {...props}>
      <UnreadDividerLine />
      <UnreadDividerPill>
        <UnreadDividerIcon />
        <UnreadDividerLabel>{label}</UnreadDividerLabel>
      </UnreadDividerPill>
      <UnreadDividerLine />
    </UnreadDividerRow>
  );
});

UnreadMessagesDivider.displayName = "UnreadMessagesDivider";

export default UnreadMessagesDivider;
